export default __webpack_public_path__ + "static/digital_twin_card_desktop-5204316d84d8b40c40a2dd76ba1d2163.png";